export const lightTheme = {
  'bg-primary': '#FFFDF8',
  'bg-secondary': '#FFF7ED',
  'bg-tertiary': '#FFF0DB',
  'bg-card': 'rgba(255, 255, 255, 0.75)',
  'text-primary': '#1A0E04',
  'text-secondary': '#2D1B0E',
  'text-muted': '#8B6E4E',
  'accent-primary': '#FF8C42',
  'accent-secondary': '#FF6B35',
  'border-light': 'rgba(255, 140, 66, 0.08)',
  'border-medium': 'rgba(255, 140, 66, 0.15)',
  'shadow-soft': '0 4px 24px rgba(255, 140, 66, 0.04)',
  'shadow-accent': '0 3px 12px rgba(255, 107, 53, 0.25)',
  'code-bg': '#1E1E2E',
  'radius-sm': '8px',
  'radius-md': '12px',
  'radius-lg': '16px',
} as const;

export const darkTheme = {
  'bg-primary': '#1C1510',
  'bg-secondary': '#181210',
  'bg-tertiary': '#140F0C',
  'bg-card': 'rgba(255, 240, 220, 0.04)',
  'text-primary': '#F5E6D3',
  'text-secondary': '#D4C4B0',
  'text-muted': '#9B8673',
  'accent-primary': '#FF8C42',
  'accent-secondary': '#FF6B35',
  'border-light': 'rgba(255, 140, 66, 0.1)',
  'border-medium': 'rgba(255, 140, 66, 0.18)',
  'shadow-soft': '0 4px 24px rgba(0, 0, 0, 0.35)',
  'shadow-accent': '0 3px 12px rgba(255, 107, 53, 0.25)',
  'code-bg': '#0D0D1A',
  'radius-sm': '8px',
  'radius-md': '12px',
  'radius-lg': '16px',
} as const;

export type ThemeTokens = typeof lightTheme;
export type ThemeMode = 'light' | 'dark';
